import React from 'react';
import {
    Box,
    Center} from '@chakra-ui/react';

const NotAllowed = () => (<Center h="400px">
    <Box p="40px" fontSize="xl">
        Nothing is here
    </Box>
</Center>);

export default NotAllowed;

